<ng-container *ngIf="render$ | async" /><ng-container *ngIf="render$ | async" />

<div id="cutout-form" class="h-full flex flex-row space-x-6 items-stretch">
  <div class="cutout-list-wrapper h-full basis-200" cslPerfectScrollbar>
    <csl-plate-cutout-list
      [editable]="editable"
      [panel]="panel"
      [groupId]="groupId"
      (formChanged)="this.formChanged.emit($event)">
    </csl-plate-cutout-list>
  </div>

  <div cslPerfectScrollbar class="flex flex-col items-start flex-1">
    <csl-svg-workspace class="panel-schema" #svgWorkspace [p]="panel"> </csl-svg-workspace>
  </div>
</div>
